<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formClick" :formData="formData"></FORM>
    <table-page ref="childTable"   @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>

import UPDATE from "@/components/page/update.vue";
import tablePage from "@/components/page/table.vue";
import FORM from "@/components/page/form.vue";
import URL from "@/views/mis/util/url";
import {dataChange} from '@/utils/dataChange';

const osOptionList = [
  {key: "android", value: "Android"},
  {key: "ios", value: "iOS"}
];
let clientMap = {};

export default {
  components: {
    FORM,
    UPDATE,
    tablePage
  },
  created () {
    this.statusOptionList = [
      {key: "true", value: window.$t("mis.bt.enable")},
      {key: "false", value: window.$t("mis.bt.disable")}
    ];
    this.getClientOptions();
  },
  mounted(){
    // console.log("Option list: ", this.clientOptionList);
    this.$set(this.formData.cols[3], "optionList", this.clientOptionList);
    this.$set(this.formData.cols[4], "optionList", this.statusOptionList);
    this.$set(this.updateData.cols[4], "optionList", this.clientOptionList);
    this.$forceUpdate();
  },
  methods: {
    formClick (clickName, data) {
      // console.log("formClick: ", clickName, data);
      if (clickName === "init") {
        this.$refs.childTable.defaultQueryData(this.queryData);
      } else if (clickName === "query") {
        this.queryData = data;
        if(this.queryData.status !== undefined) this.queryData.status = Boolean(this.queryData.status);
        // console.log("query", this.queryData);
        this.$refs.childTable.defaultGetData(this.queryData);
      } else if (clickName === "add") {
        this.modalData = {};
        this.$refs.childUpdate.open(this.modalData);
      }
    },
    bthClick (clickName, row) {
      // console.log("bthClick: ", clickName, row);
      if (clickName === "update") {
        this.modalData = {...row};
        // console.log("Update data: ", this.modalData);
        this.$refs.childUpdate.open(this.modalData);
      } else if (clickName === "delete") {
        if (!row.id) this.$message.error(window.$t("mis.appChannel.message.invalid"));
        this.delete(row.id)
      } else if (clickName === "activate") {
        if (!row.id) this.$message.error(window.$t("mis.socialMedia.message.invalid"));
        this.activate(row)
      }
    },
    submit (payload) {
      if (payload.os) {
        payload.os = Array.of(payload.os).join(",");
      }
      if(payload.client) {
        payload.client = Array.of(payload.client).join(",");
      }
      this.saveOrUpdate(payload);
    },
    getClientOptions () {
      dataChange(URL.appChannel.client, {}, (res) => {
        if(res.code === 0) {
          let data = res.result ? res.result : [];
          clientMap = data.reduce((acc, current) => {
            acc[current.engName] = current.chiName;
            return acc;
          }, {});
          console.log(res, clientMap);
          for (const [key, value] of Object.entries(clientMap)) {
            this.clientOptionList.push({key: key, value: value});
          }
        }
      }, (err) => {this.errorHandle(err)})
    },
    saveOrUpdate (data) {
      let url = URL.appChannel.save;
      if (data.id) {
        url = URL.appChannel.update;
      }
      // console.log("saveOrUpdate", url, data);
      dataChange(url, data, (res) => {
        // console.log(res);
        if (res.code === 0) {
          if(res.result) {
            this.$message.success(window.$t("mis.appChannel.message.success"));
          } else {
            this.$message.error(window.$t("mis.appChannel.message.fail") +
              window.$t("mis.appChannel.message.duplicate"));
          }
          this.$refs.childUpdate.close();
          this.modalData = {};
        }
      }, (err) => {this.errorHandle(err)}, "POST", "json").then(() => {
        this.$refs.childUpdate.close();
        this.refreshTable();
      });
    },
    activate (row) {
      row.status = !row.status;
      if(row.os && Array.isArray(row.os)) row.os = row.os.join(",");
      if(row.client && Array.isArray(row.client)) row.client = row.client.join(",");
      this.saveOrUpdate(row);
    },
    delete (id) {
      // console.log("delete: ", id);
      let url = URL.appChannel.delete + id;
      // console.log("delete", url);
      dataChange(url, {}, (res) => {
        // console.log(res);
        if (res.code === 0) {
          this.successHandle(res);
        }
      }, (err) => {this.errorHandle(err)}).then(() => {
        this.refreshTable();
      });
    },
    successHandle (success) {
      if(success.result) {
        this.$message.success(window.$t("mis.appChannel.message.success"));
      } else {
        this.$message.error(window.$t("mis.appChannel.message.fail"));
      }
    },
    errorHandle(error) {
      const errorMessage =
        (error.response && error.response.data && error.response.data.message) ||
        window.$t("mis.appChannel.message.unknown");
      this.$message.error(
        window.$t("mis.appChannel.message.fail") + ": " + errorMessage
      );
    },
    refreshTable() {
      this.$refs.childTable.defaultGetData(this.queryData);
      this.$forceUpdate();
    }

  },
  data() {
    return {
      // OptionList data
      clientOptionList: [],
      statusOptionList: [],
      // Data
      queryData:{},
      modalData:{},
      // Query form
      formData: {
        hasLable : true,
        initClickName: "init",
        cols:[
          { title: window.$t("mis.appChannel.form.name.label"), field: "name" },
          { title: window.$t("mis.appChannel.form.flavor.label"), field: "flavor" },
          { title: window.$t("mis.common.fromTime.label"), field: "fromTime",type: 5, format: "yyyy-MM-dd HH:mm:ss",
            placeholder: window.$t("mis.common.fromTime.placeholder") },
          { title: window.$t("mis.common.toTime.label"), field: "toTime",type: 5, format: "yyyy-MM-dd HH:mm:ss",
            placeholder: window.$t("mis.common.toTime.placeholder") },
          { title: window.$t("mis.appChannel.form.os.label"), field: "os", type: 2, optionList: osOptionList },
          { title: window.$t("mis.appChannel.form.client.label"), field: "client", type: 2, optionList: [] },
          { title: window.$t("mis.common.status"), field: "status", type: 2, optionList: [] },
          { buttonLabel: window.$t("mis.bt.query"), click: "query"},
          { buttonLabel: window.$t("mis.bt.add"), click: "add"}
        ]
      },
      // Table
      pageData: {
        queryUrl: URL.appChannel.query,
        method: "post-json",
        fieldData: "data",
        fieldTotal: "recordsFiltered",
        sequence: true,
        cols: [
          { title: "ID", field: "id", hidden: true },
          { title: window.$t("mis.appChannel.table.name"), field: "name" },
          { title: window.$t("mis.appChannel.table.flavor"), field: "flavor" },
          { title: window.$t("mis.appChannel.table.os"), field: "os", render:(data, full) => {
              return Array.isArray(data) && data.length > 0 ? data.join(",") : ""
            } },
          { title: window.$t("mis.appChannel.table.client"), field: "client", render:(data, full) => {
            if(Array.isArray(data) && data.length > 0) {
              return data.map(item => {
                return clientMap[item];
              }).join(", ");
            }
            return "";
            } },
          { title: window.$t("mis.common.status"), field: "status", render:(data, full) => {
              return data ? window.$t("mis.bt.enable") : window.$t("mis.bt.disable");
            } },
          { title: window.$t("mis.common.remark"), field: "remark" },
          { title: window.$t("mis.common.createdAt"), field: "createdAt" },
          { title: window.$t("mis.common.updatedAt"), field: "updatedAt", render:(data, full) => {
              return data ? data : "";
            } },
          { title: window.$t("mis.bt.operation"), btnClick: [
              { name: (data, row) => {
                  if(row.status === true) return window.$t("mis.bt.disable");
                  if (row.status === false) return window.$t("mis.bt.enable");
                }, field: "status", size: "mini", click: "activate", type: "primary", icon: "el-icon-edit" },
              { name: window.$t("mis.bt.edit"), size: "mini", click: "update", type: "primary", icon: "el-icon-edit" },
              { name: window.$t("mis.bt.delete"), size: "mini", click: "delete", type: "danger", icon: "el-icon-delete" }
            ]
          }
        ]
      },
      // Add/Update modal
      updateData: {
        cols: [
          { title: "ID", field: "id", hidden: true},
          { title: window.$t("mis.appChannel.modal.name.label"), field: "name", require: true,
            placeholder: window.$t("mis.appChannel.modal.name.placeholder") },
          { title: window.$t("mis.appChannel.modal.flavor.label"), field: "flavor", require: true,
            placeholder: window.$t("mis.appChannel.modal.flavor.placeholder") },
          { title: window.$t("mis.appChannel.modal.os.label"), field: "os", type: 4, optionList: osOptionList, data:[], require: true },
          { title: window.$t("mis.appChannel.modal.client.label"), field: "client", type: 4, optionList: [], data:[], require: true },
          { title: window.$t("mis.common.remark"), field: "remark", textType: "textarea", require: false }
        ]
      }
    }
  }
}

</script>

<style scoped>

</style>
